import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { SiretSuggestion } from "@shared-kernel/application/ports/siret-search/siret-search-repository";

export const searchSiret = createAsyncThunk<SiretSuggestion[], { query: string; signal?: AbortSignal }, { extra: Partial<Dependencies> }>(
  "shared/siret/search",
  async ({ query, signal }, { extra: { siretSearchRepository } }) => {
    return siretSearchRepository!.searchSiret(query, signal);
  },
);
